<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">历史数据</h1>
			<div class="clear marBottom20">
				<el-select class="select1" @change="clickDataType()" v-model="data_type" placeholder="请选择数据类别">
		        	<el-option label="动环数据" key="1" value="1"></el-option>
		        	<el-option label="机柜数据" key="2" value="2"></el-option>
		        </el-select>
				<el-select class="select1" @change="clickCom()" value-key="uid" v-if="administrators!=1 && administrators!=2" v-model="selectComId" placeholder="请选择公司">
					<el-option label="所有公司" key="-1" value=""></el-option>
		          <el-option v-for="com in comList" :label="com.company" :key="com.uid" :value="com.company_id"></el-option>
		        </el-select>
		        <el-select class="select1"  v-if="data_type!=2" @change="getBoxList()" v-model="selectAreaId" placeholder="请选择区域">
		          <el-option v-for="(area,index) in areaList" v-if="area.group_name=='动环'" :label="area.group_name" :key="index" :value="area.packet_id"></el-option>
		        </el-select>
		        <el-select class="select1"  v-if="data_type==2" @change="getBoxList()" v-model="selectAreaId" placeholder="请选择区域">
		          <el-option v-for="(area,index) in areaList" v-if="area.group_name!='动环'" :label="area.group_name" :key="index" :value="area.packet_id"></el-option>
		        </el-select>
		        <el-select class="select1" v-model="selectBoxMac" placeholder="请选择网关盒">
		          <el-option v-for="(box,index) in macList" :label="box.device_name" :key="index" :value="box.mac_address"></el-option>
		        </el-select>
		        
			    <button class="btn btn-ldsk-default" @click="getDeviceList(1)"> 查 看 </button>
			</div>
			
			<el-table
		    	stripe
				border
			    ref="multipleTable"
			    :data="cDevList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
			    <el-table-column
			    	v-if="data_type!='1'"
			      prop="name"
			      label="设备名称">
			    </el-table-column>
			    <el-table-column
			    	v-if="data_type=='1'"
			      prop="cn_name"
			      label="设备名称">
			    </el-table-column>
			    <el-table-column
			      prop="device_name"
			      label="采集设备名称"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="mac_address"
			      label="MAC地址"
			      show-overflow-tooltip>
			    </el-table-column>
			   
			    <el-table-column
		          label="操作"
		          show-overflow-tooltip>
		          <template slot-scope="scope">
		          	<el-button type="text" size="small"
		                       @click="toTerminalDev(scope.$index, scope.row)"> 查看历史数据 
		            </el-button>
		     
		          </template>
		        </el-table-column>
			  </el-table>
	  			<br />
				<div class="text-right">
					<el-pagination
						@current-change="handleCurrentChange"
					  :page-size="pagesize"
					  layout="total, prev, pager, next"
					  :total="totalNum">
					</el-pagination>
				</div>
		</div>
		
	    <loading v-if="showLoading"></loading>
	</div>
</template>

<script>
	export default {
		mounted() {
			
			this.$nextTick(function(){
				if(this.administrators!=1 && this.administrators!=2){
					this.getCompanyList();
				}
		  		if(this.administrators==1 || this.administrators==2){
					this.clickCom();
				}
				this.getDeviceList();
				
		  	})
    	},
    	data(){
    		return{
    			cDevList:[],
    			nowPage:1,
    			totalNum:0,
    			pagesize:12,
    			mac_address:"",
    			unbindAdminFlag:false,
    			formLabelWidth:"120px",
    			unbindDevice:{},
    			showLoading:false,
    			administrators:this.getCookie('administrators'),
    			company_id:this.getCookie('company_id'),
		  		selectAreaId:null,
    			areaList:[],
    			comList:[],
    			selectComId:null,
    			selectCom:{},
    			selectBoxMac:"",
    			macList:[],
    			data_type:""
    		}
    	},
    	methods:{
    		toTerminalDev(index,row){
    			let routeUrl;
    			if(this.data_type=='1'){
    				routeUrl = this.$router.resolve({
				          path: "/device/dataCenterDetailEnv",
				          query: {
				          	id:row.id,
				          	device_name:row.device_name,
				          	name:row.cn_name
				          }
				     });
    			}else{
    				routeUrl = this.$router.resolve({
				          path: "/device/dataCenterDetail",
				          query: {
				          	id:row.id,
				          	device_name:row.device_name,
				          	name:row.name
				          }
				     });
    			}
				
			     window.open(routeUrl.href, '_blank');
			},
			clickDataType(){
				this.clickCom;
			},
//			获取网关盒设备列表
			getBoxList(){
				this.macList = [];
				this.selectBoxMac = "";
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:1,
					pagesize:999,
					mac_address:"",
					company_id:this.selectComId || "",
					packet_id:this.selectAreaId || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
			  		
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DeviceManage/DeviceList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		if(res.data.data.datalist){
		        			this.macList = res.data.data.datalist || [];
		        		}
		        		
		        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  		
			},
			//			点击选择公司
			clickCom(){
				this.areaList = [];
				this.selectAreaId = null;
				this.macList = [];
				this.selectBoxMac = "";

//				点击公司后MAC地址设为空
				this.mac_address = "";
//				点击公司后赋值当前选中区域为空
				this.selectAreaId = null;
				//超级管理员和普通管理员分别管理
				if(this.administrators!=1 && this.administrators!=2){
					//点击赋值当前选中公司
					for(var i=0;i<this.comList.length;i++){
						if(this.comList[i].company_id == this.selectComId){
							this.selectCom = this.comList[i];
						}
					}	
				}else{
					this.selectCom.uid = this.getCookie('uid');
				}

				let valiCodeParams={
					uid:this.selectCom.uid || -1,
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/PacketList/PacketList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 && res.data.data!=null){
		        		this.areaList = res.data.data
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			获取公司列表
			getCompanyList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		timestamp:Date.parse( new Date()),
			  		terminalId:4,
			  		type:2,
		  			company_id:this.getCookie('company_id'),
		  			page:"1",
	  				pagesize:"9999",
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AdministratorsList/AdministratorsList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1 & res.data.data!=null){
		        		if(res.data.data.name){
		        			this.comList = res.data.data.name || [];
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
    		getDeviceList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					page:this.nowPage,
					pagesize:this.pagesize,
					mac_address:this.selectBoxMac || "",
					company_id:this.selectComId || "",
					packet_id:this.selectAreaId || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
			  		
		  		};
		  		this.sign2(valiCodeParams);
//		  		机柜历史数据地址
		  		var hrefRequest;
//		  		1是动环,2是机柜
		  		if(this.data_type=="1"){
		  			hrefRequest = "/admin/MoveRecord/MoveDeviceList";
		  		}else{
		  			hrefRequest = "/admin/MountRecord/MountDeviceList";
		  		}

		  		this.$ajax.post(this.$store.state.domain2+hrefRequest,this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		if(res.data.data.datalist){
		        			this.cDevList = res.data.data.datalist || [];
		        			this.totalNum = res.data.data.totalNumber;
		        		}
		        		
		        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
		  		this.mac_address = "";
		  		
			},

//			分页点击事件
			handleCurrentChange(val){
				this.nowPage = val;
				this.getDeviceList();
			},


    	}
   }
</script>

<style>
	.search-box3{
		margin-top: -88px;
	}
</style>


// WEBPACK FOOTER //
// src/components/device/dataCenter.vue